'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// eg: TemplateComponents.Container.Editor --> Editor is the MODE.

var EDITOR = exports.EDITOR = 'Editor';
var TOOLBOX = exports.TOOLBOX = 'Toolbox';
var EMAIL = exports.EMAIL = 'Email';
var BASKET = exports.BASKET = 'Basket';


//////////////////
// WEBPACK FOOTER
// ./src/constants/templateModeTypes.js
// module id = 128
// module chunks = 0